"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeOrganization = exports.decodeUser = exports.decodeMetadata = exports.UserMetadata = exports.getCurrentUser = exports.EmptyUser = exports.User = exports.MessagingChannelType = void 0;

var uuid_1 = require("./support/uuid");

var user_1 = __importStar(require("./http/user"));

var user_metadata_1 = require("./http/user_metadata");

var MessagingChannelType;

(function (MessagingChannelType) {
  MessagingChannelType[MessagingChannelType["NotApplicable"] = 0] = "NotApplicable";
  MessagingChannelType[MessagingChannelType["Email"] = 1] = "Email";
})(MessagingChannelType = exports.MessagingChannelType || (exports.MessagingChannelType = {}));

;

var User =
/** @class */
function () {
  function User(id, email, name, creationDate, lastSeen, visits, organization, active, readOnly, passwordExpired, isDeveloper, isTester, isService, messagingChannels, activeCredentials) {
    if (active === void 0) {
      active = true;
    }

    if (readOnly === void 0) {
      readOnly = false;
    }

    if (passwordExpired === void 0) {
      passwordExpired = false;
    }

    if (isDeveloper === void 0) {
      isDeveloper = false;
    }

    if (isTester === void 0) {
      isTester = false;
    }

    if (isService === void 0) {
      isService = false;
    }

    if (messagingChannels === void 0) {
      messagingChannels = [];
    }

    if (activeCredentials === void 0) {
      activeCredentials = [];
    }

    this.id = id;
    this.email = email;
    this.name = name;
    this.creationDate = creationDate;
    this.lastSeen = lastSeen;
    this.visits = visits;
    this.organization = organization;
    this.active = active;
    this.readOnly = readOnly;
    this.passwordExpired = passwordExpired;
    this.isDeveloper = isDeveloper;
    this.isTester = isTester;
    this.isServiceUser = isService;
    this.messagingChannels = messagingChannels;
    this.activeCredentials = activeCredentials;
  }

  User.prototype.get = function (credentials) {
    var _this = this;

    user_1.default(credentials, this.id).then(function (resp) {
      var u = exports.decodeUser(resp);
      _this.email = u.email;
      _this.name = u.name;
      _this.creationDate = u.creationDate;
      _this.lastSeen = u.lastSeen;
      _this.visits = u.visits;
      _this.organization = u.organization;
      _this.active = u.active;
      _this.readOnly = u.readOnly;
      _this.passwordExpired = u.passwordExpired;
      _this.isDeveloper = u.isDeveloper;
      _this.isTester = u.isTester;
      _this.isServiceUser = u.isServiceUser;
      _this.messagingChannels = u.messagingChannels;
      return _this;
    });
  };

  User.prototype.getAllMetadata = function (domain, credentials) {
    return user_metadata_1.get(credentials, domain).then(function (resp) {
      if (resp != null) {
        return resp.map(function (r) {
          return exports.decodeMetadata(r);
        });
      }

      return [];
    });
  };

  User.prototype.getMetadatum = function (domain, key, credentials) {
    var m = new UserMetadata(domain, key);
    m.get(credentials);
    return m;
  };

  User.prototype.setMessagingChannel = function (channel, credentials) {
    return user_1.setChannel(channel, credentials);
  };

  return User;
}();

exports.User = User;

exports.EmptyUser = function () {
  var org = {
    id: uuid_1.EmptyUUID(),
    name: "",
    parent: undefined,
    inheritDevices: false,
    inheritScopes: false
  };
  return new User(uuid_1.EmptyUUID(), "", "", new Date(), new Date(), 0, org, false);
};

exports.getCurrentUser = function (credentials) {
  return user_1.default(credentials).then(function (resp) {
    return exports.decodeUser(resp);
  });
};

var UserMetadata =
/** @class */
function () {
  function UserMetadata(domain, key, value) {
    if (value === void 0) {
      value = "";
    }

    this.domain = domain;
    this.key = key;
    this.value = value;
  }

  UserMetadata.prototype.get = function (credentials) {
    var _this = this;

    return user_metadata_1.get(credentials, this.domain, this.key).then(function (res) {
      if (res != null) {
        _this.value = res[0].value;
        return exports.decodeMetadata(res[0]);
      }

      return _this;
    });
  };
  /** set sets the metadata, it returns a promise of the API action, however if the optional allowEmpty parameter isn't set to true and an empty
    *  value is passed in it will return undefined and not the promise
    *
    *  Parameters:
    *   - @param {Credentials} credentials - The API access credentials
    *   - @param {boolean} allowEmpty - (optional: default false) if we should set the value even if it is empty
    *
    *  @return Either a promise of the metadata put operation or undefined if the metadata value is empty and allowEmpty is false (default)
    */


  UserMetadata.prototype.set = function (credentials, allowEmpty) {
    if (allowEmpty === void 0) {
      allowEmpty = false;
    }

    if (this.value.length > 0 || allowEmpty) {
      return user_metadata_1.put(credentials, this.domain, this.key, this.value);
    } else {
      console.warn("Metadata set called with no value, not setting");
    }
  };

  return UserMetadata;
}();

exports.UserMetadata = UserMetadata;

exports.decodeMetadata = function (m) {
  return new UserMetadata(m.domain, m.key, m.value);
};

exports.decodeUser = function (u) {
  var activeCredentials = [];

  if (u.activeTokens != null && u.activeTokens.length > 0) {
    activeCredentials = u.activeTokens;
  }

  if (u.user != null) {
    u = u.user;
  }

  var uuid;

  if (typeof u.id === "string") {
    uuid = new uuid_1.UUID(u.id);
  } else {
    uuid = new uuid_1.UUID(u.id._uuid);
  }

  var name = u.displayName;

  if (name == null || name.length === 0) {
    name = u.name;
  }

  var isService = u.usServiceUser;

  if (name == null) {
    isService = u.isService;
  }

  var email = u.email;

  if (typeof u.email === "string") {
    email = u.email;
  } else {
    email = u.email.Address;
  }

  var org = exports.decodeOrganization(u.organization);
  return new User(uuid, email, name, u.creationDate, u.lastSeen, u.visits, org, u.active, u.readOnly, u.passwordExpired, u.isDeveloper, u.isTester, isService, u.messagingChannels, activeCredentials);
};

exports.decodeOrganization = function (o) {
  var uuid;

  if (typeof o.id === "string") {
    uuid = new uuid_1.UUID(o.id);
  } else {
    uuid = new uuid_1.UUID(o.id._uuid);
  }

  return {
    id: uuid,
    name: o.displayName,
    inheritDevices: o.inheritDevices,
    inheritScopes: o.inheritScopes,
    parent: undefined
  };
};